import { Box, Typography } from "@mui/material";
/* eslint-disable no-unused-vars */
import React, { FC, useEffect, useState } from "react";

import { HOSPITAL_OPEN_KEY } from "../../config/params";
import HospitalTimings from "./HospitalTimings";
import { ILocationContentfulData } from "../../services/contentful-service/contentful.interface";
import { createDate } from "../../utils/date";
import { getHospitalTimingArray } from "../../utils/genericUtils";
import { getLocationDetails } from "../../services/contentful-service/contentfulClient.service";
import { useHospitalOpenCheck } from "../../hooks/useHospitalOpenCheck";

type IHomeHospitalDetails = {
  locationName: string
  setHospitalDetailsContent?: (content: any) => void;
}


const HomeHospitalDetails: FC<IHomeHospitalDetails> = (props) => {
  const { setHospitalDetailsContent, locationName } = props;
  const [hospitalDetails, setHospitalDetails] = useState<ILocationContentfulData | null>(null);
  const { setIsHospitalOpened } = useHospitalOpenCheck();


  useEffect(() => {
    let isMounted = true;

    getLocationDetails(locationName)
      .then((hospitalDetails: ILocationContentfulData | null) => {
        if (isMounted) {
          setHospitalDetails(hospitalDetails);
          setHospitalDetailsContent && setHospitalDetailsContent(hospitalDetails);
        }
      });

    return () => {
      isMounted = false;
      setHospitalDetails(null);
    };
  }, [locationName]);

  useEffect(()=>{
    if (hospitalDetails) {
      const openingHospitalDate = createDate(hospitalDetails.fields.openingDay as number,
        hospitalDetails.fields.openingMonth as number, hospitalDetails.fields.openingYear as number);

      if (openingHospitalDate instanceof Date && !isNaN(openingHospitalDate.getTime())) {
        localStorage.setItem(HOSPITAL_OPEN_KEY, openingHospitalDate.toISOString());
      } else {
        localStorage.removeItem(HOSPITAL_OPEN_KEY);
        setIsHospitalOpened(true);
      }
    }
  }, [hospitalDetails]);

  return (
    <>
      <Box className="bg-white p-4 flex flex-col gap-1">
        <Typography className="text-gv-gold font-bold text-xs capitalize">your home hospital</Typography>
        <Typography className="!text-2xl font-semibold">{hospitalDetails?.fields.name}</Typography>
        <Typography className="text-xs">
          {`${hospitalDetails?.fields.address}, 
            ${hospitalDetails?.fields.city}, 
            ${hospitalDetails?.fields.state}, 
            ${hospitalDetails?.fields.zipCode}.`}
        </Typography>
        <hr className="my-3" />
        <HospitalTimings
          timings={hospitalDetails && hospitalDetails.fields.schedule ?
            getHospitalTimingArray(hospitalDetails.fields.schedule as Array<string>) :
            []}
        />
      </Box>
    </>
  );
};

export default HomeHospitalDetails;
